import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RoadDto } from '../../models/road.dto';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoadService {

  private readonly path = '/road';
     
  constructor(private http: HttpClient) {}
     
  getAll(): Observable<RoadDto[]> {
    return this.http.get<RoadDto[]>(`${environment.apiBaseUrl}${this.path}`);
  }
}
